// สร้างโดย scripts/fetch-hero-photos.ts อย่าแก้เอง (ภาพ public domain หรือ CC0 จาก Wikimedia Commons)

import type { HeroKey, HeroPhoto } from "./hero-photos";

export const GENERATED_PHOTOS: Readonly<Partial<Record<HeroKey, HeroPhoto>>> = {
  "tropical_dry_forest": {
    "file": "/img/hero/tropical_dry_forest.jpg",
    "title": "1632x1224 sertaoe rio grande do norte landscape panorama brasil.jpg",
    "artist": "Everythere",
    "license": "Public domain",
    "source": "https://commons.wikimedia.org/wiki/File%3A1632x1224_sertaoe_rio_grande_do_norte_landscape_panorama_brasil.jpg"
  },
  "temperate_broadleaf_forest": {
    "file": "/img/hero/temperate_broadleaf_forest.jpg",
    "title": "Beech and ferns in Gullmarsskogen.jpg",
    "artist": "W.carter",
    "license": "CC0",
    "source": "https://commons.wikimedia.org/wiki/File%3ABeech_and_ferns_in_Gullmarsskogen.jpg"
  },
  "temperate_conifer_forest": {
    "file": "/img/hero/temperate_conifer_forest.jpg",
    "title": "Angel's Rest (Unsplash).jpg",
    "artist": "Brandon Mattingly brandonmattingly",
    "license": "CC0",
    "source": "https://commons.wikimedia.org/wiki/File%3AAngel's_Rest_(Unsplash).jpg"
  },
  "temperate_grassland": {
    "file": "/img/hero/temperate_grassland.jpg",
    "title": "Frenchman River Valley.jpeg",
    "artist": "Caitlin Mroz",
    "license": "Public domain",
    "source": "https://commons.wikimedia.org/wiki/File%3AFrenchman_River_Valley.jpeg"
  },
  "flooded_grassland": {
    "file": "/img/hero/flooded_grassland.jpg",
    "title": "Sunset over the River of Grass, NPSphoto, G.Gardner (9255157507).jpg",
    "artist": "Everglades NPS from Homestead, Florida, United States",
    "license": "Public domain",
    "source": "https://commons.wikimedia.org/wiki/File%3ASunset_over_the_River_of_Grass%2C_NPSphoto%2C_G.Gardner_(9255157507).jpg"
  },
  "tundra": {
    "file": "/img/hero/tundra.jpg",
    "title": "Andrew Loewen 2014 (Unsplash).jpg",
    "artist": "Andrew Loewen loewenandrew",
    "license": "CC0",
    "source": "https://commons.wikimedia.org/wiki/File%3AAndrew_Loewen_2014_(Unsplash).jpg"
  },
  "mediterranean": {
    "file": "/img/hero/mediterranean.jpg",
    "title": "Chaparral Neighborhood Trail (32634112387).jpg",
    "artist": "San Bernardino Nat'l Forest",
    "license": "Public domain",
    "source": "https://commons.wikimedia.org/wiki/File%3AChaparral_Neighborhood_Trail_(32634112387).jpg"
  },
  "mangrove": {
    "file": "/img/hero/mangrove.jpg",
    "title": "Mangroves in Thailand.jpg",
    "artist": "Satu Katja",
    "license": "CC0",
    "source": "https://commons.wikimedia.org/wiki/File%3AMangroves_in_Thailand.jpg"
  },
  "rock_ice": {
    "file": "/img/hero/rock_ice.jpg",
    "title": "Aialik Glacier from a boat.jpg",
    "artist": "RndmCrs",
    "license": "CC0",
    "source": "https://commons.wikimedia.org/wiki/File%3AAialik_Glacier_from_a_boat.jpg"
  },
  "coastal_sea": {
    "file": "/img/hero/coastal_sea.jpg",
    "title": "Acropora coral ffs.jpg",
    "artist": "Andy Collins, NOAA",
    "license": "Public domain",
    "source": "https://commons.wikimedia.org/wiki/File%3AAcropora_coral_ffs.jpg"
  },
  "default": {
    "file": "/img/hero/default.jpg",
    "title": "08020047.JPG",
    "artist": "Catalina Holguin",
    "license": "Public domain",
    "source": "https://commons.wikimedia.org/wiki/File%3A08020047.JPG"
  },
  "tropical_moist_forest": {
    "file": "/img/hero/tropical_moist_forest.jpg",
    "title": "150th Anniversary of U S Department of Agriculture-Historical imagery (20120106-OC-AMW-0416).jpg",
    "artist": "USDAgov",
    "license": "Public domain",
    "source": "https://commons.wikimedia.org/wiki/File%3A150th_Anniversary_of_U_S_Department_of_Agriculture-Historical_imagery_(20120106-OC-AMW-0416).jpg"
  },
  "tropical_conifer_forest": {
    "file": "/img/hero/tropical_conifer_forest.jpg",
    "title": "FvfBokod0174 03.JPG",
    "artist": "Judgefloro",
    "license": "Public domain",
    "source": "https://commons.wikimedia.org/wiki/File%3AFvfBokod0174_03.JPG"
  },
  "montane_grassland": {
    "file": "/img/hero/montane_grassland.jpg",
    "title": "Entre cerros, agua.jpg",
    "artist": "Luigi Chtaeau-forte",
    "license": "CC0",
    "source": "https://commons.wikimedia.org/wiki/File%3AEntre_cerros%2C_agua.jpg"
  },
  "desert": {
    "file": "/img/hero/desert.jpg",
    "title": "Milky Way over dunes in Great Sand Dunes National Park, Colorado, United States.jpg",
    "artist": "NPS/Patrick Myers",
    "license": "Public domain",
    "source": "https://commons.wikimedia.org/wiki/File%3AMilky_Way_over_dunes_in_Great_Sand_Dunes_National_Park%2C_Colorado%2C_United_States.jpg"
  },
  "tropical_savanna": {
    "file": "/img/hero/tropical_savanna.jpg",
    "title": "Mara River Massai Mara.jpg",
    "artist": "Morris Pügner",
    "license": "Public domain",
    "source": "https://commons.wikimedia.org/wiki/File%3AMara_River_Massai_Mara.jpg"
  },
  "open_ocean": {
    "file": "/img/hero/open_ocean.jpg",
    "title": "Blue ocean surface (Unsplash).jpg",
    "artist": "Lionello DelPiccolo liodp",
    "license": "CC0",
    "source": "https://commons.wikimedia.org/wiki/File%3ABlue_ocean_surface_(Unsplash).jpg"
  },
  "boreal_forest": {
    "file": "/img/hero/boreal_forest.jpg",
    "title": "Misty Black Spruce Forest (5079093414).jpg",
    "artist": "USFWSAlaska",
    "license": "Public domain",
    "source": "https://commons.wikimedia.org/wiki/File%3AMisty_Black_Spruce_Forest_(5079093414).jpg"
  }
};
